import { confirmAlert } from 'react-confirm-alert';

import type { GroupId } from '@vlabs/api/artemy/model';

import { AttachDepartmentGroupsConfirmation } from './AttachDepartmentGroupsConfirmation';
import type { ConfirmAttachDepartmentGroups } from './types';
import { getGroup } from '@vlabs/api/artemy/client';

export interface ConfirmAttachDepartmentGroupsProps extends ConfirmAttachDepartmentGroups {
  groupIds: [GroupId];
  onConfirm: VoidFunction;
  onReject?: VoidFunction;
}

export type ConfirmAttachDepartmentGroupsResult = 'confirmed' | 'cancelled';

export async function confirmAttachDepartmentGroups({
  departmentId,
  groupIds,
  onConfirm,
  onReject = undefined,
}: ConfirmAttachDepartmentGroupsProps): Promise<ConfirmAttachDepartmentGroupsResult> {
  const [groupId] = groupIds;
  const group = await getGroup(groupId);
  const ownerDepartmentId = group.owner_department;

  if (!ownerDepartmentId || departmentId === ownerDepartmentId) return 'confirmed';

  return new Promise<ConfirmAttachDepartmentGroupsResult>((resolve) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <AttachDepartmentGroupsConfirmation
            departmentId={ownerDepartmentId}
            onConfirm={() => {
              onConfirm();
              resolve('confirmed');
              onClose();
            }}
            onReject={() => {
              onReject?.();
              resolve('cancelled');
              onClose();
            }}
          />
        );
      },
    });
  });
}
